import Image from "next/image"

export const MenuLogoResponse = () => {
  return (
    <div>
        <Image src="/img/logo-response.webp" alt="Colegio Albert Einstein" height={100} width={100} className="lg:hidden w-[40px] h-[50px]" />

    </div>
  )
}
